import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=4b752a7c"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=4b752a7c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b752a7c')) {
      api.createRecord('4b752a7c', component.options)
    } else {
      api.reload('4b752a7c', component.options)
    }
    module.hot.accept("./BankDetailsForm.vue?vue&type=template&id=4b752a7c", function () {
      api.rerender('4b752a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/PayoutMethods/BankDetailsForm.vue"
export default component.exports